import { withNamespaces } from "react-i18next";
import { Col, Container, Row } from "reactstrap";
import Navigator from "src/components/navigator";
import CreateBatch from "./components/create-batch";

const EudrDueDiligenceDeclare = ({ t }) => {
    return (
        <div className='page-content thirdparty-questionnaire'>
            <Container fluid>
                <Row>
                    <Col sm='12'>
                        <Navigator
                            breadCrumbs={[
                                {
                                    title: 'SIP',
                                    link: '/third-party/3rd-party/home'
                                },
                                {
                                    title: t('My reports'),
                                    link: '/third-party/3rd-party/reports'
                                },
                                {
                                    title: t('EUDR Due Diligence'),
                                    link: '/third-party/3rd-party/eudr-due-diligence'
                                },
                                {
                                    title: t('Report'),
                                    link: '#'
                                }
                            ]}
                            pageTitle={t('EUDR Due Diligence Report')}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col sm='12'>
                        <CreateBatch />
                    </Col>
                </Row>
            </Container>
        </div>
    )
};

export default withNamespaces()(
    EudrDueDiligenceDeclare
);